var map = {
	"./wedding_jun@2x_en-US.png": 387,
	"./wedding_jun@2x_ko-KR.png": 388,
	"./wedding_jun@2x_zh-CN.png": 389
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 386;


//////////////////
// WEBPACK FOOTER
// ./src/assets/intro ^\.\/wedding_jun@2x_.*\.png$
// module id = 386
// module chunks = 0